module.exports = __webpack_public_path__ + "img/logoaeterablack.30d53150.png";